import { createSlice } from '@reduxjs/toolkit';
import { listClearance } from './clearanceThunk';


const initialState = {
  getListClearance: {
    loading: false,
    success: false,
    error: null,
    data: [],
  }
};

const clearanceSlice = createSlice({
  name: 'clearance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    
      .addCase(listClearance.pending, (state) => {
        state.getListClearance.loading = true;
        state.getListClearance.error = null;
      })
      .addCase(listClearance.fulfilled, (state, action) => {
        state.getListClearance.loading = false;
        state.getListClearance.data = action.payload;
      })
      .addCase(listClearance.rejected, (state, action) => {
        state.getListClearance.loading = false;
        state.getListClearance.error = action.payload || 'Somthing wents wrong.';
      })
  },
});

export default clearanceSlice.reducer;